/* import __COLOCATED_TEMPLATE__ from './project-latest-version-info.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();